const subscriptionDetailsKeys = {
  // Subscription Details
  "subscription.details.subscription": "Suscripción {{type}}",
  "subscription.details.set-to-cancel": "Marcado para cancelar",
  "subscription.details.next-billing": "Próximo período de facturación",
  "subscription.details.cancel-date": "Fecha de cancelación",
  "subscription.details.seats": "Plazas",
  "subscription.details.discount": "Descuento",
  "subscription.details.discount.none": "Ninguno",
  "subscription.details.scheduled-change": "Cambio programado",
  "subscription.details.scheduled-change.none": "Ninguno",
  "subscription.details.scheduled-change.pending": "{{quantity}} plazas desde {{date}}",
  "subscription.details.account-savings": "Ahorros de la cuenta",

  // Actions
  "subscription.details.action.manage": "Gestionar",
  "subscription.details.action.renew": "Renovar",
  "subscription.details.action.cancel-scheduled-change": "Cancelar cambio",

  // Alerts
  "subscription.details.alert.cancel": "Tu suscripción se cancelará el {{date}}. Seguirás teniendo acceso hasta entonces.",

  // Notifications
  "subscription.details.cancel-scheduled-change.notification.success.title": "Cambio programado cancelado",
  "subscription.details.cancel-scheduled-change.notification.success.message": "Se eliminó la actualización pendiente de tu suscripción.",
  "subscription.details.cancel-scheduled-change.notification.error.title": "No se pudo cancelar el cambio programado",
  "subscription.details.cancel-scheduled-change.notification.error.message": "Vuelve a intentarlo o contacta con soporte si el problema persiste.",
  "subscription.details.cancel-scheduled-change.dialog.title": "¿Cancelar cambio programado?",
  "subscription.details.cancel-scheduled-change.dialog.message": "Esto eliminará la actualización pendiente y mantendrá tu suscripción actual sin cambios.",
  "subscription.details.cancel-scheduled-change.dialog.confirm": "Cancelar cambio programado",

  // Tabs
  "subscription.details.tab": "Suscripción {{number}}",
};

export const subscriptionDetails = {
  ...subscriptionDetailsKeys,
};
